import { ID, RoleOption, Roles } from '@griply/types';

export const withRoles = <Data extends object>(
  data: Data,
  owner: ID,
  uids: ID[] = [owner],
): Data & { roles: Roles } => ({
  ...data,
  roles: {
    [RoleOption.Owner]: owner,
    [RoleOption.All]: uids,
  },
});
